import { Suspense } from 'react';

import ErrorBoundary from './lib/components/ErrorBoundary';
import LbJsonLdContainer from './lib/components/LbJsonLdContainer';
import LoadMore from './lib/components/LoadMore';
import ShowNewPosts from './lib/components/ShowNewPosts';
import { defaults } from './lib/defaults';
import LbContainter from './lib/Main';
import { LbContextProvider } from './lib/model/store';
import type { LbOptions } from './lib/types';

export * from './lib/components/templates';
export { default as usePostsUpdates } from './lib/hooks/useBus';
export { useOptions } from './lib/hooks/useOptions';
export { usePosts } from './lib/hooks/usePosts';
export * from './lib/utils';
export * from './lib/types';

export { default as Placeholder } from './lib/components/Placeholder';
export { default as Container } from './lib/components/templates/Container';
export { default as Header } from './lib/components/templates/Header';
export { default as PartsRenderer } from './lib/components/templates/PartsRenderer';
export { LbContextProvider, LbContainter, LoadMore, ShowNewPosts };

const Liveblog = ({ options }: { options: LbOptions }) => {
  const {
    showLoadMore,
    hideNewPosts,
    showJsonLD,
    customComponents: { loadMore: LoadMoreComponent = LoadMore, showNewPosts: ShowNewPostsComponent = ShowNewPosts },
  } = { ...defaults, ...options };

  return (
    <LbContextProvider options={options}>
      <Suspense>{showLoadMore && <LoadMoreComponent />}</Suspense>
      <Suspense>{hideNewPosts && <ShowNewPostsComponent />}</Suspense>
      <LbContainter />
      {showJsonLD && (
        <ErrorBoundary data='schemaorg'>
          <LbJsonLdContainer />
        </ErrorBoundary>
      )}
    </LbContextProvider>
  );
};

export default Liveblog;
